<div
    class="agpr-formField agpr-dateStyleField-container"
    role="group"
    [attr.aria-label]="field.label | localize"
>
    <div
        class="agpr-formField-heading"
    >
        <span
            class="agpr-formField-headingLabel"
        >
            {{ field.label | localize }}
        </span>
        <span
            class="agpr-formField-headingButtons"
        >
            @if(field.allowExpertMode) {
                <agpr-button
                    class="agpr-formField-headingButton"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-code"
                    tooltip="PageBuilder.formField.tooltip.expertTemplateEditor"
                    tooltipPosition="top"
                    (click)="saveExpertTemplate()"
                ></agpr-button>
            }
            <agpr-button
                class="agpr-formField-headingButton"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-floppy-disk"
                tooltip="PageBuilder.formField.tooltip.saveStyle"
                tooltipPosition="top"
                (click)="saveStyle(styleTypes.DATE)"
            ></agpr-button>
        </span>
    </div>
    <div
        class="agpr-dateStyleField"
    >
        <div class="agpr-inputGroupRow">
            <div class="agpr-inputGroupRow-dropdown">
                <agpr-dropdown-field
                    [id]="id + '.styleStateDropdown'"
                    [value]="value.displayStyleState"
                    [field]="styleStateField"
                    [updateOptions]="styleStateField.options"
                    [labelClass]="'agpr-dropdown-label--semibold'"
                    (changes)="setStyle($event, styleStateField.property)"
                >
                </agpr-dropdown-field>
            </div>
            <div
                class="agpr-inputGroupRow-buttons"
            >
                <agpr-button
                    icon="fa-regular fa-duotone fa-gear"
                    [id]="id + '.manageStyles'"
                    [style]="buttonTypes.block"
                    tooltip="PageBuilder.formField.tooltip.manageStyles"
                    tooltipPosition="top"
                    (click)="manageStylesButtonClicked()"
                >
                </agpr-button>
            </div>
        </div>
    </div>
    <div
        class="agpr-dateStyleField agpr-dateStyleField-fontSection"
        *ngIf="!value.template"
    >
        <agpr-briefing-text-style-field
            class="agpr-dateStyleField-fontCustomization"
            [id]="id + '.textStyle'"
            [field]="textStyleField"
            [value]="value.font"
            [hidePadding]="true"
            [showLabel]="false"
            (changes)="setStyle($event, textStyleField.property)"
        ></agpr-briefing-text-style-field>
        <div
            class="agpr-dateStyleField-dropdown"
        >
            <agpr-dropdown-field
                [id]="id + '.dateFormatDropdown'"
                [value]="value.dateFormat"
                [field]="dateFormatField"
                (changes)="setStyle($event, dateFormatField.property)"
            >
            </agpr-dropdown-field>
        </div>

        <div class="agpr-dateStyleField-toggles">
            <agpr-checkbox
                [id]="id + '.showTimeZone'"
                [label]="'DateStyleField.showTimeZone' | localize"
                [ngModel]="value.showTimeZone"
                (ngModelChange)="onShowTimeZoneChange($event)"
                [binary]="true"
            ></agpr-checkbox>
            @if (value.showTimeZone) {
                <div class="agpr-dateStyleField-timezonePicker">
                    <agpr-timezone-picker
                        [id]="id + '.timezone'"
                        [defaultToUserPreference]="false"
                        [ngModel]="value.timezone ?? defaultTimezone"
                        (ngModelChange)="setStyle($event, 'timezone')"
                    ></agpr-timezone-picker>
                </div>
            }
            <agpr-checkbox
                [id]="id + '.showTime'"
                [label]="'DateStyleField.showTime' | localize"
                [ngModel]="value.showTime"
                (ngModelChange)="onShowTimeChange($event)"
                [binary]="true"
            ></agpr-checkbox>
        </div>

        @if (languageFormatField) {
            <div
                class="agpr-languageStyleField-dropdown"
            >
                <agpr-dropdown-field
                    [id]="id + '.languageFormatDropdown'"
                    [value]="value.locale"
                    [field]="languageFormatField"
                    (changes)="setStyle($event, languageFormatField.property)"
                >
                </agpr-dropdown-field>
            </div>
        }

        <div class="agpr-dateStyleField-padding">
            <agpr-block-padding
                [id]="id + '_padding'"
                [(padding)]="value.padding"
                (paddingChanged)="setStyle($event, 'padding')"
            ></agpr-block-padding>
        </div>
    </div>
    <div
        class="agpr-dateStyleField"
        *ngIf="value.template"
    >
        <agpr-message
            [severity]="messageSeverityEnum.info"
        >
            {{ 'PageBuilder.styles.expertStyleAppliedPreMessage' | localize }}
            <span style="font-weight:bold">
                {{ 'Briefings.blockType.date' | localize}}
            </span>
            {{ 'PageBuilder.styles.expertStyleAppliedPostMessage' | localize }}
        </agpr-message>
    </div>
</div>

<ng-template #dateBackgroundColorPicker>
    <agpr-color-picker-field
        [id]="id + '.backgroundColorPicker'"
        [value]="value.backgroundColor"
        [field]="backgroundColorField"
        (changes)="setStyle($event, backgroundColorField.property)"
    ></agpr-color-picker-field>
</ng-template>
